import { classes } from './classes';

export const container = () => `<div class="${classes.CONTAINER} ${classes.LOADING_ICON}"></div>`;

export const canvas = () => `<canvas class="${classes.CANVAS}" width="0" height="0"> </canvas>`;
